import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import stylesConfig from '../../../../theme/config';

function HeadingLarge({
  text, cy, children, sx,
}) {
  return (
    <Typography
      component="h2"
      variant="h2"
      data-cy={cy}
      sx={{
        font: stylesConfig.typography.boldHeading.font,
        letterSpacing: stylesConfig.typography.boldHeading.letterSpacing,
        ...sx,
      }}
    >
      {children}
      {text}
    </Typography>
  );
}

HeadingLarge.defaultProps = {
  cy: 'heading-bold',
  sx: undefined,
};

HeadingLarge.propTypes = {
  cy: PropTypes.string,
  sx: PropTypes.shape({}),
  // children: PropTypes.oneOfType([
  //   PropTypes.arrayOf(PropTypes.node),
  //   PropTypes.node,
  // ]),
};
export default HeadingLarge;
